// `storageKey`, `checksum`, `catalog` and `jsonSchema` are never requested by this endpoint's
// serialization groups: they never appear on this payload, unlike the version detail one.
export type DocumentTemplateVersionPayload = {
	readonly id: number;
	readonly organization: { readonly id: number };
	readonly template: { readonly id: number };
	readonly versionNumber: number;
	readonly originalFilename: string;
	readonly fieldCount: number;
	readonly createdAt: string;
	readonly updatedAt: string;
};

export type DocumentTemplateVersionsFetchedPayload = DocumentTemplateVersionPayload[];

export type DocumentTemplateVersionsFetchedAction = {
	type: 'DOCUMENT_TEMPLATE_VERSIONS_FETCHED';
	payload: DocumentTemplateVersionsFetchedPayload;
	organizationId: number;
};

export default (
	payload: DocumentTemplateVersionsFetchedPayload,
	organizationId: number,
): DocumentTemplateVersionsFetchedAction => ({
	type: 'DOCUMENT_TEMPLATE_VERSIONS_FETCHED',
	payload,
	organizationId,
});
